import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { CreditCard } from "utils/CreditCard";
import Styles from "components/general/CreditCardInput.module.scss"
import { Amex } from "components/creditcard/Amex";
import { Diners } from "components/creditcard/Diners";
import { Elo } from "components/creditcard/Elo";
import { Aura } from "components/creditcard/Aura";
import { Hipercard } from "components/creditcard/Hipercard";
import { Mastercard } from "components/creditcard/Mastercard";
import { Visa } from "components/creditcard/Visa";
import { Discover } from "components/creditcard/Discover";
import { Jcb } from "components/creditcard/Jcb";

export class CreditCardInput extends Component {
  constructor (props) {
    super(props);

    this.state = {
      flag: "",
      flagId: "",
      number: "",
      maskedNumber: "",
      cvv: "",
      expMonth: "",
      expYear: "",
      nameOnCard: "",
      
      cvvIsValid: false,
      numberIsValid: false,
      expMonthIsValid: false,
      expYearIsValid: false,
      dateIsValid: false, 
      nameOnCardIsValid: false,
      
      submitted: false
    };
  }
  
  _renderCvvInvalid = () => {
    if (this.state.submitted === true && this.state.cvv !== "" && !this.state.cvvIsValid) {
      return (
        <div className={Styles["cc__invalid-feedback"]}>
          CVV Inválido
        </div>
      );
    }
    return null;
  };
  
  _renderNumberInvalid = () => {
    if (this.state.submitted === true && this.state.number !== "" && !this.state.numberIsValid) {
      return (
        <div className={Styles["cc__invalid-feedback"]}>
          Número Inválido
        </div>
      );
    }
    return null;
  };
  
  _renderNameOnCardInvalid = () => {
    if (this.state.submitted === true && this.state.nameOnCard !== "" && !this.state.nameOnCardIsValid) {
      return (
        <div className={Styles["cc__invalid-feedback"]}>
          Campo Obrigatório
        </div>
      );
    }
    return null;
  };
  
  _renderDateInvalid = () => {
    if (
      this.state.submitted === true 
      && this.state.expMonth !== "" 
      && this.state.expYear !== "" 
      && (
        !this.state.dateIsValid 
        || !this.state.expMonthIsValid 
        || !this.state.expYearIsValid 
      ) 
    ) {
      return (
        <div className={Styles["cc__invalid-feedback"]}>
          Data Inválida
        </div>
      );
    }
    return null;
  };

  render () {
    let {
      number,
      cvv,
      expMonth,
      expYear,
      nameOnCard
    } = this.state;
    
    return (
      <form className={Styles["cc"]} onSubmit={this.submitCreditCard}>
        <h5 className={"mb-1"}>Troca de Cartão</h5>
        <p className={"caption"}>
          Preencha o formulário abaixo com os dados do seu novo cartão de crédito.
        </p>

        <div className={Styles["cc__form-group"]}>
          <label>
            Nome
          </label>
          <div className={Styles["cc__input-group"]}>
            <input type={"text"} 
                   name={"nameOnCard"} 
                   value={nameOnCard} 
                   required
                   onChange={this.updateFormItem}/> 
          </div>
          {this._renderNameOnCardInvalid()}
        </div>
        
        <div className={Styles["cc__form-group"]}>
          <label>
            Número
          </label>
          <div className={Styles["cc__number-group"]}>
            <input type={"tel"} 
                   name={"number"} 
                   value={number}
                   required 
                   onChange={this.updateFormItem}/> 
            <span className={Styles["cc__flag"]}>
              {this.renderFlag()}
            </span>
          </div>
          {this._renderNumberInvalid()}
        </div>
        
        <div className={Styles["cc__form-row"]}>
          <div className={classnames(Styles["cc__form-group"], Styles["w_66"])}>
            <label>
              Data (MM/YYYY)
            </label>
            <div className={Styles["cc__date-group"]}>
              <input type={"tel"} 
                     name={"expMonth"} 
                     value={expMonth} 
                     placeholder={"MM"}
                     required
                     onChange={this.updateFormItem}/> 
              <input type={"tel"} 
                     name={"expYear"} 
                     value={expYear} 
                     placeholder={"YYYY"}
                     required
                     onChange={this.updateFormItem}/> 
            </div>
            {this._renderDateInvalid()}
          </div>
          <div className={classnames(Styles["cc__form-group"], Styles["w_33"])}>
            <label>
              CVV
            </label>
            <div className={Styles["cc__cvv-group"]}>
              <input type={"tel"} 
                     name={"cvv"} 
                     value={cvv}
                     required 
                     onChange={this.updateFormItem}/> 
            </div>
            {this._renderCvvInvalid()}
          </div>
        </div>

        {(() => {
          if (this.props.onSave) {
            return (
              <button type={"submit"} className={Styles["cc__submit"]}>
                Salvar
              </button>
            );
          }
        })()}
        
        {(() => {
          if (this.props.onCancel) {
            return (
              <button type={"button"} className={Styles["cc__cancel"]} onClick={this.cancelModal}>
                Cancelar
              </button>
            );
          }
        })()}
      </form>
    );
  }

  cancelModal = () => {
    if (this.props.onCancel) this.props.onCancel();
  };

  updateFormItem = (e) => {
    let {
      name, 
      value 
    } = e.target;
  
    let date = new Date();

    let state = {};

    switch (name) {
      case "nameOnCard":
        value = value;
        
        state["nameOnCardIsValid"] = (value !== "");
        break;

      case "number":
        value = this.sanitize(value);
        let flag = CreditCard.getCardFlag(value),
            repetition = false;
        state["flag"] = (flag) ? flag.slug : null;
        state["flagId"] = (flag) ? flag.id : null;

        for (let n = 0; n < 9; n++) {
          let len = value.length,
              rgx = new RegExp(`^${n}{${len}}`);

          if (len > 8 && rgx.test(value)) repetition = rgx.test(value);
        }
        
        state["numberIsValid"] = (
          CreditCard.validateDigit(value) 
            && CreditCard.validateModulo(value)
            && !repetition
        );
        value = CreditCard.formatCard(value);

        let maskedNumber = CreditCard.maskCard(value);
        state["maskedNumber"] = maskedNumber;
        break;

      case "expMonth":
        value = this.sanitize(value);
        if (value.length > 2) value = value.substring(0, 2);
        state["expMonthIsValid"] = (parseInt(value) >= 1 && parseInt(value) <= 12);
        break;

      case "expYear":
        value = this.sanitize(value);
        if (value.length > 2) value = value.substring(0, 4);
        value = parseInt(value);

        state["expYearIsValid"] = (
          value >= date.getFullYear()
        );
        break;

      case "cvv":
        value = this.sanitize(value);
        if (value.length > 2) value = value.substring(0, 5);
        
        state["cvvIsValid"] = (value !== "");
        break;

      default:
        value = this.sanitize(value);
        break;
    }

    state[name] = value;
    
    state["submitted"] = false;

    this.setState(
      state,
      () => {
        let dateIsValid;

        if (date.getFullYear() === parseInt(this.state.expYear)) {
          dateIsValid = (parseInt(this.state.expMonth) >= date.getMonth() + 1);
        } else if (parseInt(this.state.expYear) > date.getFullYear()) {
          dateIsValid = (
            parseInt(this.state.expMonth) >= 1 
            && parseInt(this.state.expMonth) <= 12
          );
        } else {
          dateIsValid = false;
        }

        this.setState({
          dateIsValid
        });

        if (this.onUpdate) {
          this.saveCreditCard();
        }
      }
    );
  };
  
  renderFlag = () => {
    if (this.state.flagId !== null && this.state.flagId !== undefined) {
      switch (this.state.flagId) {
        case 1:
          return <Visa size={63}/>;
        case 2:
          return <Mastercard size={63}/>;
        case 3:
          return <Amex size={63}/>;
        case 4:
          return <Diners size={63}/>;
        case 5:
          return <Hipercard size={63}/>;
        case 6:
          return <Elo size={63}/>;
        case 7:
          return <Discover size={63}/>;
        case 8:
          return <Aura size={63}/>;
        case 9:
          return <Jcb size={63}/>;
      }
    }
    
    return null;
  };

  saveCreditCard = () => {
    const {
      cvvIsValid, 
      numberIsValid, 
      expMonthIsValid, 
      expYearIsValid, 
      dateIsValid, 
      nameOnCardIsValid,
      flag, 
      flagId, 
      number, 
      maskedNumber, 
      cvv, 
      expMonth, 
      expYear, 
      nameOnCard
    } = this.state;
    
    if (
      cvvIsValid
      && numberIsValid
      && expMonthIsValid
      && expYearIsValid
      && dateIsValid
      && nameOnCardIsValid
    ) {
      if  (this.props.onUpdate) {
        this.props.onUpdate({
          flag, 
          flagId, 
          number: this.sanitize(number), 
          maskedNumber, 
          cvv, 
          expMonth, 
          expYear, 
          nameOnCard
        });
      }
    } else {
      this.forceUpdate();
    }
  };
  
  submitCreditCard = (e) => {
    e.preventDefault();
    
    const {
      cvvIsValid, 
      numberIsValid, 
      expMonthIsValid, 
      expYearIsValid, 
      dateIsValid, 
      nameOnCardIsValid,
      flag, 
      flagId, 
      number, 
      maskedNumber, 
      cvv, 
      expMonth, 
      expYear, 
      nameOnCard
    } = this.state;
    
    this.setState({
      submitted: true
    });
    
    if (
      cvvIsValid
      && numberIsValid
      && expMonthIsValid
      && expYearIsValid
      && dateIsValid
      && nameOnCardIsValid
    ) {
      if (this.props.onSave) {
        this.props.onSave({
          flag, 
          flagId, 
          number: this.sanitize(number), 
          maskedNumber, 
          cvv, 
          expMonth, 
          expYear, 
          nameOnCard
        });
      }
    }
  }

  sanitize = (value) => {
    if (typeof value !== "string") {
      value = value.toString();
    }
    
    return value.replace(/[^\d]+/g, "");
  };
}

CreditCardInput.propTypes = {
  onSave: PropTypes.func,
  onUpdate: PropTypes.func,
  onCancel: PropTypes.func
};
